import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TransactionTypesNotAllowedModal = ({ show, onClose, getTransactionsNotAllowedText }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Operaciones limitadas')} size="m">
      <Styles.Container>
        <Text type="bodyMRegular">
          {t('La política de devoluciones no permite {{transactionTypes}} de productos desde tu región.', {
            transactionTypes: getTransactionsNotAllowedText(),
          })}
        </Text>
        <Text type="bodyMRegular">
          {t(
            'Si eliges esta opción para alguno de los productos de tu pedido, tendrás que enviarlos desde otra región que lo permita.'
          )}
        </Text>
        <Text type="bodyMRegular">{t('Por favor, tenlo en cuenta a la hora de hacer tu solicitud.')}</Text>
        <Button onClick={onClose}>{t('Aceptar')}</Button>
      </Styles.Container>
    </Modal>
  )
}

export default TransactionTypesNotAllowedModal
